import { WidgetHost, NewsWidget, WidgetContainerContext } from '@/core/widgets/export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons';
import PinnedArticlePage from '@/modules/articles/pages/pinned-article-page';
import { PinnedWidgetPreferences, PinnedWidgetState } from './pinned-series-widget';
import { RouteObject } from 'react-router-dom';
import articleApi from '@/modules/articles/api/article-api';
import PinnedWidgetMenuActions from '@/modules/articles/components/pins/pinned-widget-menu-actions';
import { AnalyticsSubTypeEvent } from '@/shared/analytics/export';

export class PinnedArticleWidget implements NewsWidget<PinnedWidgetState, PinnedWidgetPreferences> {
  defaultTitle = 'Pinned Article';
  constructor(private readonly articleId: string) {}

  get id(): string {
    return `/pinned/${this.articleId}`;
  }

  async hasPermission(permissions: string[]) {
    return true;
  }

  initialize(host: WidgetHost) {}
  get headerPanel(): JSX.Element {
    return (
      <WidgetContainerContext.Consumer>
        {widgetContainer => (
          <>
            <span className={'w-100 position-relative'}>
              {widgetContainer.getState<PinnedWidgetState>()?.title ?? this.defaultTitle}
            </span>
            <span
              className={'position-fixed  w-100 text-center overflow-visible '}
              style={{
                top: -5,
                left: 0,
                // Just needs to sit above this widget's own header text —
                // not above the app's real overlay tiers (topbar/bottom
                // bar/fullscreen panels/search, all under 1050).
                zIndex: 1,
                pointerEvents: 'none',
                overflow: 'visible !important',
                overflowClipMargin: 'unset',
                overflowAnchor: 'unset',
                overflowBlock: 'visible',
              }}
            >
              <img src={'/tape.png'} width={'150px'} alt={'pin'} />
            </span>
          </>
        )}
      </WidgetContainerContext.Consumer>
    );
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  menuActions(close: () => void): React.ReactNode {
    return (
      <PinnedWidgetMenuActions
        close={close}
        defaultColor="note-blue"
        colorChangeEvent={AnalyticsSubTypeEvent.PINNED_ARTICLE_COLOR_CHANGE}
      />
    );
  }

  get shortTitle(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faThumbtack} />
      </>
    );
  }

  containerClass(state?: PinnedWidgetState, preferences?: PinnedWidgetPreferences) {
    return `${preferences?.color ?? 'note-blue'} sticky-note shadow-sm`;
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: (
          <WidgetContainerContext.Consumer>
            {widgetContainer => (
              <PinnedArticlePage
                className={
                  widgetContainer.getPreferences<PinnedWidgetPreferences>()?.color ?? 'note-blue'
                }
              />
            )}
          </WidgetContainerContext.Consumer>
        ),
        loader: async () => {
          try {
            const article = await articleApi.getArticle(this.articleId || '');
            const title = article.headline;

            return { article, title, loaded: true };
          } catch (e) {
            return e;
          }
        },
      },
    ];
  }

  get defaultRoute(): string {
    return '';
  }
}
